import { Swiper } from 'swiper/bundle';
import 'swiper/css/effect-fade';

document.addEventListener('DOMContentLoaded', function () {
  const body = document.body;
  const scrollUp = 'direction-up';
  const scrollDown = 'direction-down';
  const header = document.getElementById('header');
  const navbar = document.getElementById('navbar');

  if (header) {
    var headerTransparent = document.getElementById('headerTrans');
    if (headerTransparent) {
      header.setAttribute('data-transparent', 'true');
      navbar.classList.add('navbar-transparent');
      header.classList.add('header-visible');
    } else {
      header.classList.add('header-visible');
    }
  }

  var scrollTopId = document.getElementById('scrollTop');
  var lastScrollTop = 0;

  AOS.init({
    once: true,
  });

  // sidemenu
  const sidemenu = document.getElementById('sidemenu-toggler');
  const productInquiry = document.getElementById('modalProductInquiry');

  if (sidemenu) {
    sidemenu.addEventListener('click', function (e) {
      body.classList.toggle('sidemenu-open');
    });
  }

  if (productInquiry) {
    productInquiry.addEventListener('show.bs.modal', function (e) {
      body.classList.add('product-inquiry-open');
    });

    productInquiry.addEventListener('hidden.bs.modal', function (e) {
      body.classList.remove('product-inquiry-open');
    });

    window.addEventListener('click', function (e) {
      if (!document.querySelector('.sidemenu-header').contains(e.target)) {
        body.classList.remove('sidemenu-open');
      }
    });
  }

  // end of sidemenu

  if (navbar) {
    var st = getScrollYPosition();
    if (st > 0) {
      navbar.classList.remove('navbar-transparent');
    }
  }

  var coverSliderId = document.getElementById('sliderCover');
  if (coverSliderId) {
    var coverSliderNav = coverSliderId.querySelector('.slider-nav');
    var coverSlider = new Swiper(coverSliderId, {
      effect: 'fade',
      speed: 500,
      autoplay: {
        delay: 5000,
      },
      slidesPerView: 1,
      slideActiveClass: 'slider-item-active',
    });

    coverSlider.on('slideChange', function () {
      Array.from(coverSlider.slides).forEach(function (slide) {
        if (slide.classList.contains('has-video')) {
          var video = slide.getElementsByTagName('video');
          video[0].classList.add('pause');
          video[0].pause();
        }
      });
      var navElements = coverSliderNav.querySelectorAll('.slider-nav-item');
      navElements.forEach(function (navElement) {
        navElement.classList.remove('active');
        if (navElement.dataset.slideIndex == coverSlider.activeIndex) {
          navElement.classList.add('active');
        }
      });
    });

    coverSlider.on('slideChangeTransitionStart', function () {
      if (coverSlider.slides[coverSlider.realIndex].classList.contains('has-video')) {
        var video = coverSlider.slides[coverSlider.realIndex].getElementsByTagName('video');
        video[0].play();
      }
    });

    coverSliderNav.querySelectorAll('li > a').forEach(function (el, key) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        coverSliderId.setAttribute('data-slider-autoplay', 'false');
        el.parentNode.classList.add('active');
        coverSlider.slideTo(el.parentNode.dataset.slideIndex);

        coverSliderNav.querySelectorAll('li').forEach(function (ell, els) {
          if (key !== els) {
            ell.classList.remove('active');
          }
        });
      });
    });
  }

  var sliderPeopleID = document.getElementById('sliderPeople');
  var sliderPeople = new Swiper(sliderPeopleID, {
    speed: 500,
    slidesPerView: 4,
    simulateTouch: false,
    navigation: {
      disabledClass: 'slider-control-disabled',
      hiddenClass: 'slider-control-hidden',
      lockClass: 'slider-control-lock',
      nextEl: '.slider-control-next',
      prevEl: '.slider-control-prev',
    },
    pagination: {
      modifierClass: 'slider-pagination-',
      progressbarFillClass: 'slider-pagination-progressbar-fill',
      el: '.slider-pagination-progressbar',
      type: 'progressbar',
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      576: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
    },
    slideActiveClass: 'slider-item-active',
  });

  var sliderStandardID = document.getElementById('sliderStandard');
  if (sliderStandardID) {
    var sliderStandard = new Swiper(sliderStandardID, {
      speed: 500,
      slidesPerView: 4,
      simulateTouch: false,
      navigation: {
        disabledClass: 'slider-control-disabled',
        hiddenClass: 'slider-control-hidden',
        lockClass: 'slider-control-lock',
        nextEl: sliderStandardID.querySelector('.slider-control-next'),
        prevEl: sliderStandardID.querySelector('.slider-control-prev'),
      },
      pagination: {
        progressbarFillClass: 'slider-pagination-progressbar-fill',
        el: sliderStandardID.querySelector('.slider-pagination-progressbar'),
        type: 'progressbar',
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        576: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      },
      slideActiveClass: 'slider-item-active',
    });
  }

  var sliderConsumablesID = document.getElementById('sliderConsumables');
  if (sliderConsumablesID) {
    var sliderConsumables = new Swiper(sliderConsumablesID, {
      speed: 500,
      slidesPerView: 4,
      simulateTouch: false,
      navigation: {
        nextEl: sliderConsumablesID.querySelector('.slider-control-next'),
        prevEl: sliderConsumablesID.querySelector('.slider-control-prev'),
        disabledClass: 'slider-control-disabled',
      },
      pagination: {
        progressbarFillClass: 'slider-pagination-progressbar-fill',
        el: sliderConsumablesID.querySelector('.slider-pagination-progressbar'),
        type: 'progressbar',
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        576: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      },
      slideActiveClass: 'slider-item-active',
    });
  }

  // testimonial tabs
  var testimonialsTabList = [].slice.call(
    document.querySelectorAll('.nav-testimonial-tabs [data-bs-toggle="tab"]')
  );
  testimonialsTabList.forEach(function (testimonialTab) {
    testimonialTab.addEventListener('shown.bs.tab', function (e) {
      if (e.target) {
        var tabPaneID = e.target.getAttribute('href');
        var tabPane = document.querySelector(tabPaneID);
        var tabVideo = tabPane.getElementsByTagName('video');
        if (tabVideo.length > 0) {
          tabVideo[0].play();
        }
      } else if (e.relatedTarget) {
        var tabPaneID = e.relatedTarget.getAttribute('href');
        var tabPane = document.querySelector(tabPaneID);
        var tabVideo = tabPane.getElementsByTagName('video');
        if (tabVideo.length > 0) {
          tabVideo[0].pause();
        }
      }
    });
  });

  // testimonials
  var sliderTestimonialSelector = document.querySelector('.slider-testimonial');
  if (sliderTestimonialSelector) {
    var sliderTestimonial = new Swiper(sliderTestimonialSelector, {
      navigation: {
        disabledClass: 'slider-control-disabled',
        hiddenClass: 'slider-control-hidden',
        lockClass: 'slider-control-lock',
        nextEl: sliderTestimonialSelector.querySelector('.slider-control-next'),
        prevEl: sliderTestimonialSelector.querySelector('.slider-control-prev'),
      },
      on: {
        init: function () {
          var pagerCurent = this.el.querySelector('.slider-pager-numbers > .slider-pager-current'),
            pagerTotal = this.el.querySelector('.slider-pager-numbers > .slider-pager-total');
          pagerCurent.innerHTML = '0' + (this.activeIndex + 1);
          pagerTotal.innerHTML = '0' + this.slides.length;
        },
        slideChange: function () {
          var currentSlide = '0' + (this.realIndex + 1);
          this.el.querySelector('.slider-pager-numbers > .slider-pager-current').innerHTML =
            currentSlide;
        },
      },
      effect: 'fade',
      crossFade: true,
      speed: 500,
      slidesPerView: 1,
      slideActiveClass: 'slider-item-active',
    });
  }
  // Featured Slider
  var sliderFeatureID = document.getElementById('featureSlider');
  if (sliderFeatureID) {
    var sliderFeatureNav = sliderFeatureID.querySelector('.slider-nav');
    var sliderFeature = new Swiper(sliderFeatureID, {
      effect: 'fade',
      speed: 500,
      autoplay: {
        delay: 5000,
      },
      slidesPerView: 1,
      slideActiveClass: 'slider-item-active',
    });

    sliderFeature.on('slideChangeTransitionStart', function () {
      if (sliderFeature.slides[sliderFeature.realIndex].classList.contains('has-video')) {
        var video = sliderFeature.slides[sliderFeature.realIndex].getElementsByTagName('video');
        video[0].play();
      }
    });

    sliderFeature.on('slideChange', function () {
      Array.from(sliderFeature.slides).forEach(function (slide) {
        if (slide.classList.contains('has-video')) {
          var video = slide.getElementsByTagName('video');
          video[0].classList.add('pause');
          video[0].pause();
        }
      });

      var navElements = sliderFeatureID.querySelectorAll('.slider-nav-item');
      navElements.forEach(function (navElement) {
        navElement.classList.remove('active');
        if (navElement.dataset.slideIndex == sliderFeature.activeIndex) {
          navElement.classList.add('active');
        }
      });
    });

    sliderFeatureNav.querySelectorAll('li > a').forEach(function (el, key) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        sliderFeatureID.setAttribute('data-slider-autoplay', 'false');
        el.parentNode.classList.add('active');
        sliderFeature.slideTo(el.parentNode.dataset.slideIndex);

        sliderFeatureNav.querySelectorAll('li').forEach(function (ell, els) {
          if (key !== els) {
            ell.classList.remove('active');
          }
        });
      });
    });
  }

  // Solution Slider
  let sliderSolutionID = document.getElementById('sliderSolution');
  if (sliderSolutionID) {
    let sliderSolutionOptions = {
      speed: 1000,
      simulateTouch: false,
      navigation: {
        disabledClass: 'slider-control-disabled',
        hiddenClass: 'slider-control-hidden',
        lockClass: 'slider-control-lock',
        nextEl: sliderSolutionID.querySelector('.slider-solutions .slider-control-next'),
        prevEl: sliderSolutionID.querySelector('.slider-solutions .slider-control-prev'),
      },
      on: {
        init: function () {
          var pagerCurent = this.el.querySelector('.slider-pager-current'),
            pagerTotal = this.el.querySelector('.slider-pager-total');
          pagerCurent.innerHTML = '0' + (this.activeIndex + 1);
          pagerTotal.innerHTML = '0' + this.slides.length;
        },
        slideChange: function () {
          var currentSlide = '0' + (this.realIndex + 1);
          this.el.querySelector('.slider-pager-current').innerHTML = currentSlide;
        },
      },
      slideActiveClass: 'slider-item-active',
    };
    let sliderSolution = new Swiper(sliderSolutionID, sliderSolutionOptions);

    sliderSolution.on('slideChangeTransitionStart', function () {
      if (this.slides[this.realIndex].classList.contains('has-video')) {
        var video = this.slides[this.realIndex].getElementsByTagName('video');
        video[0].play();
      }
    });

    sliderSolution.on('slideChange', function () {
      Array.from(this.slides).forEach(function (slide) {
        if (slide.classList.contains('has-video')) {
          var video = slide.getElementsByTagName('video');
          video[0].classList.add('pause');
          video[0].pause();
        }
      });
    });
  }

  // History Slider
  let sliderHistoryID = document.getElementById('sliderHistory');
  if (sliderHistoryID) {
    let sliderHistoryOptions = {
      speed: 1000,
      simulateTouch: false,
      watchSlidesProgress: true,
      navigation: {
        disabledClass: 'slider-control-disabled',
        hiddenClass: 'slider-control-hidden',
        lockClass: 'slider-control-lock',
        nextEl: '.slider-history .slider-control-next',
        prevEl: '.slider-history .slider-control-prev',
      },
      pagination: {
        progressbarFillClass: 'slider-pagination-progressbar-fill',
        el: '.slider-pagination-progressbar',
        type: 'progressbar',
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        576: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      },
      slideVisibleClass: 'slider-item-visible',
    };
    let sliderHistory = new Swiper(sliderHistoryID, sliderHistoryOptions);
  }

  //menu toggler
  let menuToggler = document.querySelector('.navbar-menu-toggler');
  if (menuToggler) {
    menuToggler.addEventListener('click', function (e) {
      menuToggler.classList.toggle('active');
      body.classList.toggle('page-menu');

      menuToggler.setAttribute(
        'aria-expanded',
        menuToggler.getAttribute('aria-expanded') === 'false' ? 'true' : 'false'
      );
    });
  }
  // menu
  var menuPrimary = document.getElementById('menuPrimary');
  if (menuPrimary) {
    var menuPrimaryParentItems = menuPrimary.querySelectorAll(
      '.menu-link[aria-haspopup] > .menu-icon'
    );
    menuPrimaryParentItems.forEach(function (menuSubToggler, key) {
      menuSubToggler.addEventListener('click', function (e) {
        e.preventDefault();
        menuSubToggler.parentNode.setAttribute(
          'aria-expanded',
          menuSubToggler.parentNode.getAttribute('aria-expanded') === 'false' ? 'true' : 'false'
        );
      });
    });
  }

  // reset password
  var forgotPassword = document.querySelector('#forgot-password');
  if (forgotPassword) {
    forgotPassword.onclick = function (e) {
      e.preventDefault();
      var linkResetpassword = document.querySelector('#account-nav-tabs .nav-item-password a');
      var tabResetPassword = new bootstrap.Tab(linkResetpassword);
      tabResetPassword.show();
    };
  }
  // account
  let modalAccount = document.getElementById('modalAccount');

  if (modalAccount) {
    modalAccount.addEventListener('hidden.bs.modal', function (e) {
      var linkSignin = document.querySelector('#account-nav-tabs .nav-item-signin a');
      var tabSignin = new bootstrap.Tab(linkSignin);
      tabSignin.show();
    });
  }
  //search
  const searchToggler = document.querySelector('.navbar-search-toggler');
  const searchInputId = document.getElementById('mainSearchInput');
  const searchPane = document.getElementById('search');

  if (searchToggler) {
    const searchTogglerIcon = searchToggler.querySelector('.sa-icon');

    const searchBackdropListener = (e) => {
      if (
        !searchPane.querySelector('.search-dialog').contains(e.target) &&
        !navbar.contains(e.target) &&
        searchPane.getAttribute('aria-expanded') === 'true'
      ) {
        body.classList.toggle('page-search');
        searchPane.setAttribute('aria-expanded', 'false');
        searchToggler.classList.remove('active');
        searchToggler.setAttribute('aria-expanded', 'false');
        searchTogglerIcon.classList.remove('sa-icon-close');
        searchTogglerIcon.classList.add('sa-icon-search');
        document.removeEventListener('click', searchBackdropListener);
      }
    };

    searchToggler.addEventListener('click', function (e) {
      e.preventDefault();
      body.classList.toggle('page-search');
      searchPane.setAttribute(
        'aria-expanded',
        searchPane.getAttribute('aria-expanded') === 'false' ? 'true' : 'false'
      );
      document.addEventListener('click', searchBackdropListener);

      if (body.classList.contains('page-search')) {
        searchTogglerIcon.classList.remove('sa-icon-search');
        searchTogglerIcon.classList.add('sa-icon-close');
        searchToggler.classList.add('active');
        searchToggler.setAttribute('aria-expanded', 'true');
        setTimeout(function () {
          setFocus(searchInputId);
        }, 400);
      } else {
        searchTogglerIcon.classList.remove('sa-icon-close');
        searchTogglerIcon.classList.add('sa-icon-search');
        searchToggler.classList.remove('active');
        searchToggler.setAttribute('aria-expanded', 'false');
      }
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      if (body.classList.contains('page-search')) {
        body.classList.remove('page-search');
        searchTogglerIcon.classList.add('sa-icon-search');
        searchTogglerIcon.classList.remove('sa-icon-close');
        searchToggler.classList.remove('active');
        searchToggler.setAttribute('aria-expanded', 'false');
      } else if (body.classList.contains('page-filter')) {
        body.classList.remove('page-filter');
      } else if (body.classList.contains('sideover-open')) {
        body.classList.remove('sideover-open');
      }
    }
  });

  //scroll to top
  if (scrollTopId) {
    scrollTopId.addEventListener('click', function (e) {
      e.stopPropagation();
      e.preventDefault();
      scroll(e.target.hash, {
        duration: 400,
      });
    });
  }

  // toggle password
  document.querySelectorAll('[data-toggle="password"]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      const target = el.dataset.target;
      document.querySelector(target).focus();
      const icon = el.querySelector('.sa-icon');

      if (document.querySelector(target).getAttribute('type') == 'password') {
        document.querySelector(target).setAttribute('type', 'text');
        icon.classList.remove('sa-icon-eye');
        icon.classList.add('sa-icon-eye-off');
      } else {
        document.querySelector(target).setAttribute('type', 'password');
        icon.classList.remove('sa-icon-eye-off');
        icon.classList.add('sa-icon-eye');
      }
    });
  });

  var docsFilterCountNum = 0;
  //documents filter
  var filterTogglerId = document.getElementById('docFilterToggler');
  var filterCloseId = document.getElementById('docFilterClose');
  var filterBackdrop = document.querySelector('.filter-backdrop');

  const docsFilterApply = document.getElementById('docs-filter-apply');

  if (filterTogglerId && filterCloseId && filterBackdrop) {
    filterTogglerId.addEventListener('click', function (e) {
      body.classList.toggle('page-filter');
    });
    filterBackdrop.addEventListener('click', function (e) {
      body.classList.remove('page-filter');
      //Uncomment if closing filter menu needs to submit form
      //docsFilterApply.click();
    });
    filterCloseId.addEventListener('click', function (e) {
      if (docsFilterCountNum > 0) {
        docsFilterApply.click();
      }
      body.classList.remove('page-filter');
    });
  }

  const docsFilterList = document.getElementById('filter-documents');
  //const docsFilterResult = document.querySelector('.js-docs-filter-result');

  if (docsFilterList) {
    docsFilterList.addEventListener('click', function (event) {
      if (!event.target.matches('.form-check-input')) return;
      docsFilterCountNum = docsFilterList.querySelectorAll('.form-check-input:checked').length;
      docsFilterCountUpdate(docsFilterCountNum);
    });
  }

  let docsFilterResetBtns = document.querySelectorAll('.js-docs-filter-reset');
  if (docsFilterResetBtns) {
    docsFilterResetBtns.forEach((btn) => {
      if (btn.classList.contains('dont-reload')) {
        btn.addEventListener('click', (e) => {
          docsFilterReset();
        });
      } else {
        btn.addEventListener('click', (e) => {
          docsFilterReset();
          docsFilterApply.click();
        });
      }
    });
  }

  let docsFilterCounts = document.querySelectorAll('.js-docs-filter-count');
  function docsFilterCountUpdate(count) {
    if (docsFilterCounts) {
      docsFilterCounts.forEach((el) => {
        el.textContent = `(${count})`;
      });
    }
  }
  function docsFilterReset() {
    docsFilterList.querySelectorAll('.form-check-input').forEach((checkbox) => {
      checkbox.checked = false;
      docsFilterCountNum = 0;
      docsFilterCountUpdate(docsFilterCountNum);
      //docsFilterResult.textContent = `0`
    });
  }

  //sideover people
  var sideoverPeopleId = document.getElementById('sideoverPeople');

  document.querySelectorAll('[data-toggle="sideover"]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      var triggerEl = document.querySelector(
        '#tabPeople > [href="' + el.getAttribute('href') + '"]'
      );
      if (triggerEl && sideoverPeopleId) {
        triggerEl.click();
        body.classList.toggle('sideover-open');
        sideoverPeopleId.setAttribute('aria-expanded', 'true');
        sideoverPeopleId.addEventListener('click', sideoverBackdrop, false);
      }
    });
  });

  var sideoverClose = document.querySelector('[data-dismiss="sideover"]');
  if (sideoverClose) {
    sideoverClose.addEventListener('click', function (e) {
      var active = document.querySelector('.sideover[aria-expanded="true"]');
      if (active) {
        body.classList.remove('sideover-open');
        active.setAttribute('aria-expanded', 'false');
      }
    });
  }
  var sideoverBackdrop = function (e) {
    if (!e.target.closest('.sideover-dialog')) {
      body.classList.remove('sideover-open');
      e.target.setAttribute('aria-expanded', 'false');
      e.target.removeEventListener('click', sideoverBackdrop, false);
    }
  };

  let featureTabsLink = document.querySelectorAll('.feature-tabs .nav-link');

  if (featureTabsLink) {
    featureTabsLink.forEach(function (tab) {
      tab.addEventListener('show.bs.tab', function (e) {
        var featureTabs = tab.closest('.feature-tabs');

        if (e.target.classList.contains('has-video')) {
          var targetTabCover = featureTabs.querySelector(
            '.tab-cover-bg[data-tabpanel="' + e.target.getAttribute('href') + '"]'
          );
          var targetTabVideo = targetTabCover.getElementsByTagName('video');
          targetTabVideo[0].play();
        }
        if (e.relatedTarget.classList.contains('has-video')) {
          var targetTabCover = featureTabs.querySelector(
            '.tab-cover-bg[data-tabpanel="' + e.relatedTarget.getAttribute('href') + '"]'
          );
          var targetTabVideo = targetTabCover.getElementsByTagName('video');
          targetTabVideo[0].pause();
        }
      });
    });
  }

  //scroll event
  if (navbar) {
    window.addEventListener(
      'scroll',
      () => {
        var st = getScrollYPosition();
        if (st > lastScrollTop) {
          // downscroll code
          body.classList.remove(scrollUp);
          body.classList.add(scrollDown);
          if (lastScrollTop == 0 && st > 75) {
            body.classList.remove(scrollDown);
          }
        } else {
          // upscroll code
          body.classList.remove(scrollDown);
          body.classList.add(scrollUp);

          if (lastScrollTop < 75 && headerTransparent) {
            navbar.classList.add('navbar-transparent');
          } else {
            navbar.classList.remove('navbar-transparent');
          }
        }
        if (st == 0) {
          body.classList.remove(scrollDown);
          body.classList.remove(scrollUp);
        }

        if (st > scrollTopId.dataset.showOffset) {
          scrollTopId.classList.add('active');
        } else {
          scrollTopId.classList.remove('active');
        }

        lastScrollTop = st <= 0 ? 0 : st;
      },
      false
    );
  }

  //load event
  window.addEventListener('load', function (e) {
    const body = document.body;
    body.classList.remove('page-preload');
    body.classList.add('page-loaded');

    if (window.location.hash) {
      var hash = window.location.hash.substring(1);

      if (hash == 'documentSection') {
        scroll('[data-anchor="#' + hash + '" i]', {
          duration: 200,
        });
        $('#documentsCollapse').collapse('show');
      } else {
        scroll('[data-anchor="#' + hash + '" i]', {
          duration: 200,
        });
      }
    }
    document.querySelectorAll('.anchor').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
        var offset;
        if (!el.hasAttribute('data-anchor-offset')) {
          offset = -80;
        } else {
          offset = el.dataset.anchorOffset;
        }

        scroll('[data-anchor="' + e.target.hash + '" i]', {
          duration: 200,
          offset: parseInt(offset),
        });
      });
    });
  });
});

function setFocus(element) {
  if (element) {
    if (!/^(?:a|select|input|button|textarea)$/i.test(element.tagName)) {
      element.tabIndex = -1;
    }

    element.focus();
  }
}

function getScrollYPosition() {
  var top = window.pageYOffset || document.documentElement.scrollTop;
  return top;
}

function scroll(target, options) {
  var start = window.pageYOffset,
    opt = {
      duration: options.duration,
      offset: options.offset || 0,
      callback: options.callback,
      easing: options.easing || easeInOutQuad,
    },
    distance =
      typeof target === 'string'
        ? opt.offset + (document.querySelector(target)?.getBoundingClientRect().top || 0)
        : target,
    duration = typeof opt.duration === 'function' ? opt.duration(distance) : opt.duration,
    timeStart,
    timeElapsed;

  requestAnimationFrame(function (time) {
    timeStart = time;
    loop(time);
  });

  function loop(time) {
    timeElapsed = time - timeStart;

    window.scrollTo(0, opt.easing(timeElapsed, start, distance, duration));

    if (timeElapsed < duration) requestAnimationFrame(loop);
    else end();
  }

  function end() {
    window.scrollTo(0, start + distance);

    if (typeof opt.callback === 'function') opt.callback();
  }

  // Robert Penner's easeInOutQuad - http://robertpenner.com/easing/
  function easeInOutQuad(t, b, c, d) {
    t /= d / 2;
    if (t < 1) return (c / 2) * t * t + b;
    t--;
    return (-c / 2) * (t * (t - 2) - 1) + b;
  }
}
